import { render } from "./NavbarView.vue?vue&type=template&id=bcf2c18a&scoped=true"
import script from "./NavbarView.vue?vue&type=script&lang=js"
export * from "./NavbarView.vue?vue&type=script&lang=js"

import "./NavbarView.vue?vue&type=style&index=0&id=bcf2c18a&lang=scss&scoped=true"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf2c18a"]])

export default __exports__